import React, { Component } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ComponentErrorView from "./ComponentErrorView";
import GlobalErrorView from "./GlobalErrorView";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: props.message || undefined,
      hasError: false,
      callback: props.callback || undefined,
      isOverridden: props.isOverridden,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error);
    this.setState(
      { hasError: true, error, errorInfo },
      () => {
        if (this.state.callback) {
          this.state.callback(this.state.hasError);
        }
      }
    );
  }

  render() {
    if (this.state.hasError && !this.state.isOverridden) {
      return (
        <>
          {this.state.message ? (
            <h2>{this.state.message}</h2>
          ) : (
            <GlobalErrorView
              error={this.state.error}
              errorInfo={this.state.errorInfo}
            />
          )}
          <Outlet />
        </>
      );
    }
    return this.props.children;
  }
}

    export const RouterAwareErrorBoundary = ({ children, message, callback, isOverridden }) => {
      const location = useLocation();
      return (
        <ErrorBoundary
          key={location.pathname}
          message={message}
          callback={callback}
          isOverridden={isOverridden}
        >
          {children}
        </ErrorBoundary>
      );
    };

  // HOCs
  export const withErrorBoundary = (WrappedComponent) => {
    return (props) => (
      <RouterAwareErrorBoundary message={<ComponentErrorView />}>
        <WrappedComponent {...props} isError={false} />
      </RouterAwareErrorBoundary>
    );
  };

export const withCustomErrorBoundary = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isError: false };
    }

    componentDidCatch(error, errorInfo) {
      console.error("WrappedComponent error:", error);
      this.setState({ isError: true });
    }

    render() {
      return <WrappedComponent {...this.props} isError={this.state.isError} />;
    }
  };
};

export default RouterAwareErrorBoundary;
